"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelVerificationEndpoint = exports.UpdateProfileEndpoint = exports.SendToVerificationEndpoint = exports.GetProfileEndpoint = void 0;
exports.GetProfileEndpoint = require("./get-profile");
exports.SendToVerificationEndpoint = require("./send-to-verification");
exports.UpdateProfileEndpoint = require("./update-profile");
exports.CancelVerificationEndpoint = require("./cancel-verification");
